import React from 'react'
import Link from 'gatsby-link'

const cancelation = () => (
  <div>
    <h2>Cancellation Policy</h2>
    <p>
      If you need to cancel our appointment, please contact me at least 24 hours
      prior to our appointment. A $50 fee will be charged for appointments
      missed with less than 24 hours notice of cancellation.
    </p>
  </div>
)

export default cancelation



// WEBPACK FOOTER //
// ./src/pages/cancelation-policy.js